import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src="https://public.readdy.ai/ai/img_res/62cb6fed-9197-40aa-b467-cf5dbb51758b.png"
              alt="VIAPREC Logo"
              className="h-10 w-auto"
            />
            <span className="text-2xl font-bold text-[#0A1628]">VIAPREC</span>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-[#00D4FF] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vpn-services')}
              className="text-gray-700 hover:text-[#00D4FF] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              VPN Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#00D4FF] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-[#00D4FF] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-[#00D4FF] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-gradient-to-r from-[#0A1628] to-[#00D4FF] text-white px-6 py-3 rounded-full font-medium hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-lock-line mr-2"></i>
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
